var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(!_vm.loading)?_c('div',{staticClass:"thank-img"},[_vm._m(0),_c('img',{attrs:{"src":require("../assets/pig-way.png"),"alt":"THANKYOU"}})]):_c('div',{staticClass:"loader"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" \"ขอบคุณที่เป็นเพื่อนกับ Porsa นะครับ\""),_c('br'),_vm._v(" เส้นทางที่แบ่งปันความรู้เพื่อสุขภาพหมูที่ดี ")])
}]

export { render, staticRenderFns }